import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../../utils/errorUtils";
import logger from "../../../utils/logger";

const initialState = {
    isApplePayAvailable: false,
    isGooglePayAvailable: false,
    googlePayClient: null
};

const digitalWalletsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'SET_APPLE_PAY_AVAILABLE':
            return {
                ...state,
                isApplePayAvailable: payload
            };
        case 'SET_GOOGLE_PAY_AVAILABLE':
            return {
                ...state,
                isGooglePayAvailable: payload
            };
        case 'SET_GOOGLE_PAY_CLIENT':
            return {
                ...state,
                googlePayClient: payload
            };
        default:
            return state;
    }
};

export const setApplePayAvailable = (isAvailable) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_APPLE_PAY_AVAILABLE', payload: !!isAvailable });
        } catch (error) {
            logger.logReduxErrorEvent(error, getErrorMessage(error), true);
        }
    }
};

export const setGooglePayAvailable = (isAvailable) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_GOOGLE_PAY_AVAILABLE', payload: !!isAvailable });
        } catch (error) {
            logger.logReduxErrorEvent(error, getErrorMessage(error), true);
        }
    }
};

export const setGooglePayClient = (client) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_GOOGLE_PAY_CLIENT', payload: client });
        } catch (error) {
            logger.logReduxErrorEvent(error, getErrorMessage(error), true);
        }
    }
};

export const useDigitalWallets = () => {
    const dispatch = useDispatch();

    return {
        isApplePayAvailable: useSelector((appState) => appState.digitalWalletsState.isApplePayAvailable),
        setApplePayAvailable: (isAvailable) => dispatch(setApplePayAvailable(isAvailable)),
        isGooglePayAvailable: useSelector((appState) => appState.digitalWalletsState.isGooglePayAvailable),
        setGooglePayAvailable: (isAvailable) => dispatch(setGooglePayAvailable(isAvailable)),
        googlePayClient: useSelector((appState) => appState.digitalWalletsState.googlePayClient),
        setGooglePayClient: (client) => dispatch(setGooglePayClient(client))
    };
};

export default digitalWalletsReducer;